<template>
  <v-container class="main-container responsive-height">
    <AllLevelTabs></AllLevelTabs>
  </v-container>
</template>

<script>
import AllLevelTabs from '@/components/TradeMaster/AllLevelTabs.vue';


export default {
  components: {
    AllLevelTabs,
  },
};
</script>
